module.exports = __webpack_public_path__ + "static/img/bp4.3c1cb06.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/articles/1911263/bp4.jpg
// module id = eV4e
// module chunks = 1